import { render, staticRenderFns } from "./SideNavV2.vue?vue&type=template&id=b404b766&scoped=true&"
import script from "./SideNavV2.vue?vue&type=script&lang=js&"
export * from "./SideNavV2.vue?vue&type=script&lang=js&"
import style0 from "./SideNavV2.vue?vue&type=style&index=0&id=b404b766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b404b766",
  null
  
)

export default component.exports